module.exports = __webpack_public_path__ + "media/images/banner/coupons/coupon-en-3ba4815e139b0029ef96584769cea885.png";